import { render, staticRenderFns } from "./addMonitorSCA.vue?vue&type=template&id=0a607f46&scoped=true&"
import script from "./addMonitorSCA.vue?vue&type=script&lang=js&"
export * from "./addMonitorSCA.vue?vue&type=script&lang=js&"
import style0 from "./addMonitorSCA.vue?vue&type=style&index=0&id=0a607f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a607f46",
  null
  
)

export default component.exports